import type { PropsWithChildren } from "react";

export const Centered = ({ children }: PropsWithChildren) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        fontFamily: "sans-serif",
        fontSize: "1.5em",
      }}
    >
      {children}
    </div>
  );
};
